import React from 'react'
import { oneOf } from 'prop-types'
import {
  Icon,
  Notice as NoticeComponent,
  InfoFilled,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const icon = <Icon color="dark" size="medium" svgComponent={InfoFilled} />

const sellerMessages = {
  promo: (
    <div>
      <strong>Important news!</strong>
      {' '}
      CGTrader is reducing commissions for 3D Projects: from 15% down to 10% per project, with a maximum commission of just $20 for projects over $200. To celebrate, your next project will be completely commission-free if it's approved before January 31.
    </div>
  ),
  standard: (
    <div>
      <strong>You're now on lower 3D Projects fees.</strong>
      {' '}
      Your 3D Projects now use our reduced 10% commission, with a $20 cap on projects over $200 - helping you keep more of your earnings on every project.
    </div>
  )
}

const buyerMessage = (
  <div>
    <strong>3D Projects update.</strong>
    {' '}
    Creator fees are now 10% (down from 15%), with a $20 cap on projects over $200 - helping you receive better offers from creators.
  </div>
)

function CommissionNotice({ audience, variant = 'promo' }) {
  const content = audience === 'seller'
    ? sellerMessages[variant] || sellerMessages.promo
    : buyerMessage

  return (
    <NoticeComponent
      type="primary"
      useSSRIcon
      ssrIcon={icon}
      className="cgt-mb-20"
    >
      {content}
    </NoticeComponent>
  )
}

CommissionNotice.propTypes = {
  audience: oneOf(['seller', 'buyer']).isRequired,
  variant: oneOf(['promo', 'standard'])
}

export default CommissionNotice
